<div class="logo-wrapper">
  <div class="logo-icon">
    <i class="bi bi-graph-up-arrow"></i>
  </div>

  <h2 class="title">KPI Manager</h2>
  <p class="subtitle">Sistema de Gestión y Reportes</p>
</div>

<form [formGroup]="form" (ngSubmit)="submit()" class="form">
  <!-- Email -->
  <label class="label">Correo electrónico</label>
  <div class="input-wrapper" [class.input-error]="form.controls.email.invalid && form.touched">
    <i class="bi bi-envelope"></i>
    <input type="email" formControlName="email" placeholder="tu@email.com" />
  </div>
  @if (form.controls.email.touched && form.controls.email.invalid) {
    <p class="error">Ingresa un correo electrónico válido</p>
  }

  <!-- Password -->
  <label class="label">Contraseña</label>
  <div class="input-wrapper" [class.input-error]="form.controls.password.invalid && form.touched">
    <i class="bi bi-lock"></i>
    <input
      [type]="showPassword() ? 'text' : 'password'"
      formControlName="password"
      placeholder="••••••••"
    />

    <button
      type="button"
      class="toggle-password"
      (click)="togglePassword()"
      aria-label="Mostrar u ocultar contraseña"
    >
      <i class="bi" [class.bi-eye]="!showPassword()" [class.bi-eye-slash]="showPassword()"></i>
    </button>
  </div>
  @if (form.controls.password.touched && form.controls.password.invalid) {
    <p class="error">La contraseña es requerida</p>
  }

  <!-- Link Olvidaste contraseña -->
  <div class="forgot-password">
    <button type="button" (click)="goToForgot()">¿Olvidaste tu contraseña?</button>
  </div>

  <!-- Botón -->
  <app-button type="submit" variant="primary" size="form" [disabled]="loading()" [fullWidth]="true">
    @if (loading()) {
      Cargando...
    } @else {
      Iniciar sesión
    }
  </app-button>

  <!-- Error general -->
  @if (error()) {
    <p class="error text-center">{{ error() }}</p>
  }
</form>
